/* ============================================================
   CULT RACING — PASSWORD GATE (cr-password)
   The drop page's front door for a password drop: winners of the
   OUTRUN game get the word by text on drop day, type it here, and
   the rack unlocks. Remembered per drop in localStorage so a
   returning buyer is not asked twice.

   The page carries only a SHA-256 of the password, never the word.
   Comparison is case-insensitive and ignores surrounding spaces,
   because it is typed from a text message on a phone.

   Honest limit: the rack is in the HTML the browser already has;
   this decides whether it is SHOWN. It keeps the drop off the
   screen of anyone without the word, which is the job for a
   13-hour drop, but it is not a server-side lock.

   Uses the same html[data-chase] gate attribute as the game, so
   cr-chase.css's hide rules apply unchanged.
   ============================================================ */
(function () {
  "use strict";
  var gate = document.getElementById("gate");
  if (!gate) return;
  var html = document.documentElement;
  var want = (gate.getAttribute("data-sha") || "").toLowerCase();
  var KEY = "cr-gate:" + (gate.getAttribute("data-gate-key") || "drop");
  var input = gate.querySelector("input[name=code]");
  var note = gate.querySelector("[data-note]");
  var btn = gate.querySelector("button[type=submit]");
  var cta = document.querySelector("[data-gate-cta]");

  function sha256(text) {
    var buf = new TextEncoder().encode(text);
    return crypto.subtle.digest("SHA-256", buf).then(function (h) {
      return Array.prototype.map.call(new Uint8Array(h), function (b) { return ("0" + b.toString(16)).slice(-2); }).join("");
    });
  }

  function open(remember) {
    html.setAttribute("data-chase", "open");
    gate.hidden = true;
    if (cta) cta.hidden = false;
    if (remember) { try { localStorage.setItem(KEY, want); } catch (e) {} }
    if (window.dataLayer && window.dataLayer.push) window.dataLayer.push({ event: "drop_gate_open" });
  }

  gate.addEventListener("submit", function (e) {
    e.preventDefault();
    var code = (input.value || "").trim().toUpperCase();
    if (!code) { input.focus(); return; }
    if (!window.crypto || !crypto.subtle) { note.textContent = "Your browser cannot check the password. Open this page in Safari or Chrome."; return; }
    btn.disabled = true;
    sha256(code).then(function (hex) {
      btn.disabled = false;
      if (hex === want) {
        note.textContent = "";
        open(true);
        setTimeout(function () {
          var rack = document.getElementById("rack");
          if (rack && rack.scrollIntoView) rack.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 200);
      } else {
        note.textContent = "Not it. Check the text you were sent.";
        gate.classList.remove("is-wrong"); void gate.offsetWidth; gate.classList.add("is-wrong");
        input.select();
      }
    }).catch(function () { btn.disabled = false; note.textContent = "Could not check that. Try again."; });
  });

  // already unlocked on this phone: the pre-paint script set data-chase=open
  if (html.getAttribute("data-chase") === "open") { gate.hidden = true; if (cta) cta.hidden = false; }
})();
